<template>
  <div v-if="stars" class="stars-module">
    <ul class="list list_stars" :class="`list_stars--${size}`">
      <li v-for="(star, index) in 5" :key="index">
        <svg
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          class="icon"
          :class="{ 'is-active': isActive(index) }"
        >
          <path
            d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"
          />
        </svg>
      </li>
    </ul>
    <span v-if="count > 0 && displayCount" class="lbl">({{ count }} {{ reviewString }})</span>
  </div>
</template>

<script>
  export default {
    props: {
      stars: { type: String, default: null },
      count: { type: Number, default: 0 },
      displayCount: { type: Boolean, default: true },
      size: { type: String, default: 'small' }, // tiny, small, medium, large
    },

    computed: {
      reviewString() {
        return this.count === 1 ? 'valoración' : 'valoraciones';
      },
    },

    methods: {
      isActive(index) {
        let iteration = index + 1;

        return iteration <= this.stars;
      },
    },
  };
</script>

<style lang="scss">
  .stars-module {
    .list_stars {
      display: inline-flex;
      vertical-align: middle;
      list-style: none;
      padding: 0;
      margin: 0;

      .icon {
        width: 12px;
        height: 12px;
        align-items: center;
        justify-content: center;
        fill: #d9d9d9;

        &.is-active {
          fill: #dfbc07;
        }
      }
    }

    .lbl {
      margin-left: 4px;
      font-family: 'Source Sans Pro', Helvetica, sans-serif;
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
      color: #9f99b2;
    }
  }
</style>
